/* Motion (owner 2026-10-13: "need smooth loader and gsap wherever theres loading ... atc text animation and all
 * things"). GSAP 3.13 + ScrollTrigger (assets/gsap.min.js, assets/gsap-scrolltrigger.min.js: cdnjs 3.13.0, SRI
 * checked, served from the theme). All of it is decoration: without GSAP, or with reduced motion, every page works
 * and shows the same content (the loading bar still shows, without easing).
 *   loading bar   a thin line at the top while a page, a sort or a cart request loads; it finishes on the next page
 *   add to cart   the button's words roll to "Adding", then "Added", then back; a shake when the add fails
 *   cart          the count badge pops on change; the drawer's lines slide in when it opens
 *   cards         cards below the fold rise into place as they scroll in (movement only, never transparent text;
 *                 not inside [data-reveal], which the CSS already moves)
 *   images        lazy photos fade in once loaded instead of popping (never a first-screen photo)
 */
(function () {
  'use strict';
  if (window.__plMotion) return;
  window.__plMotion = true;
  const g = window.gsap;
  const calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const live = !!g && !calm;
  if (g && window.ScrollTrigger) g.registerPlugin(window.ScrollTrigger);
  const store = (k, v) => {
    try {
      if (v === undefined) return sessionStorage.getItem(k);
      if (v === null) sessionStorage.removeItem(k);
      else sessionStorage.setItem(k, v);
    } catch (e) {
      /* private mode: the bar just doesn't carry over */
    }
    return null;
  };

  /* ---------------------------------------------------------------- loading bar */
  const bar = document.createElement('div');
  bar.className = live ? 'pl-loadbar' : 'pl-loadbar pl-loadbar--css';
  bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);
  let jobs = 0;
  let creep = null;
  let navTimer = 0;
  function show(from) {
    if (creep) creep.kill();
    if (live) {
      g.set(bar, {scaleX: from, opacity: 1});
      creep = g.to(bar, {scaleX: 0.9, duration: 8, ease: 'power4.out'});
    } else {
      bar.style.opacity = '1';
      bar.style.transform = 'scaleX(0.6)';
    }
  }
  function finish() {
    if (creep) creep.kill();
    if (live) {
      g.to(bar, {scaleX: 1, duration: 0.3, ease: 'power2.out', overwrite: true, onComplete: () => g.to(bar, {opacity: 0, duration: 0.35})});
    } else {
      bar.style.transform = 'scaleX(1)';
      bar.style.opacity = '0';
    }
  }
  function start() {
    if (++jobs === 1) show(0);
  }
  function done() {
    if (jobs === 0) return;
    if (--jobs === 0) finish();
  }
  window.PL = window.PL || {};
  window.PL.loading = {start, done};

  /* a page on its way: the bar runs here, and finishes on the page that opens */
  function leaving() {
    start();
    store('pl-loading', String(Date.now()));
    clearTimeout(navTimer);
    navTimer = setTimeout(() => { store('pl-loading', null); done(); }, 12000); /* a download, or a page that never came */
  }
  const left = Number(store('pl-loading') || 0);
  store('pl-loading', null);
  if (left && Date.now() - left < 15000) {
    show(0.75);
    jobs = 1;
    const land = () => done();
    if (document.readyState === 'complete') requestAnimationFrame(land);
    else addEventListener('load', land, {once: true});
  }
  addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    /* back from the browser's page cache: nothing is loading */
    clearTimeout(navTimer);
    store('pl-loading', null);
    jobs = 0;
    if (creep) creep.kill();
    bar.style.opacity = '0';
  });
  document.addEventListener('click', (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const a = event.target.closest && event.target.closest('a[href]');
    if (!a || (a.target && a.target !== '_self') || a.hasAttribute('download')) return;
    let url;
    try {
      url = new URL(a.href, location.href);
    } catch (e) {
      return;
    }
    if (!/^https?:$/.test(url.protocol) || url.origin !== location.origin) return;
    if (url.pathname === location.pathname && url.search === location.search) return;
    /* after every other handler: a link a script takes over (a menu, the zoom viewer) is not a page load */
    setTimeout(() => { if (!event.defaultPrevented) leaving(); }, 0);
  });
  document.addEventListener('submit', (event) => {
    const f = event.target;
    if (f.matches('[data-pl-add], [data-pl-kit-form], [data-cart-discount]') || (f.target && f.target !== '_self')) return;
    setTimeout(() => { if (!event.defaultPrevented) leaving(); }, 0);
  });
  /* sort reloads the collection (pl-facets); filters apply in place */
  document.addEventListener('change', (event) => {
    if (event.target.closest && event.target.closest('[data-pl-sort] select')) leaving();
  });
  /* cart requests: product forms, quick add, the drawer's steppers, the kit page, the builder */
  if (window.fetch) {
    const fetch0 = window.fetch;
    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      if (!/\/cart\/(add|change|update|clear)(\.js)?\b/.test(url)) return fetch0.apply(this, arguments);
      start();
      const p = fetch0.apply(this, arguments);
      p.then(done, done);
      return p;
    };
  }

  /* ---------------------------------------------------------------- add to cart */
  let pending = null;
  /* the words go in a span of ours (display: contents, so the button lays them out as before); while it is still
     there, nothing else has rewritten the button */
  const ours = (p) => !!p.node && p.node.parentNode === p.btn;
  function put(p, html) {
    p.btn.innerHTML = `<span class="pl-now">${html}</span>`;
    p.node = p.btn.firstElementChild;
  }
  function roll(p, html) {
    const btn = p.btn;
    if (!live) {
      put(p, html);
      return;
    }
    btn.innerHTML = `<span class="pl-roll"><span class="pl-roll__a">${btn.innerHTML}</span><span class="pl-roll__b">${html}</span></span>`;
    const track = btn.firstElementChild;
    p.node = track;
    g.fromTo(track, {yPercent: 0}, {
      yPercent: -100,
      duration: 0.34,
      ease: 'power3.inOut',
      onComplete: () => { if (p.node === track && ours(p)) put(p, html); },
    });
  }
  /* back to the button's own words, unless a script has written new ones meanwhile (a variant change) */
  function restore(p) {
    clearTimeout(p.timer);
    p.btn.classList.remove('is-adding', 'is-added');
    if (ours(p)) p.btn.innerHTML = p.html;
    p.node = null;
    p.btn.style.minWidth = p.width;
    p.btn.style.minHeight = p.height;
  }
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('form[data-pl-add], [data-pl-kit-form]')) return;
    const btn = event.submitter && event.submitter.matches('button') ? event.submitter : form.querySelector('button[type="submit"], [data-pl-kit-add]');
    if (!btn || btn.disabled) return;
    if (pending) restore(pending);
    const p = {btn, html: btn.innerHTML, width: btn.style.minWidth, height: btn.style.minHeight, node: null};
    pending = p;
    const box = btn.getBoundingClientRect();
    btn.style.minWidth = `${box.width}px`;
    btn.style.minHeight = `${box.height}px`;
    btn.classList.add('is-adding');
    roll(p, '<span class="pl-spin" aria-hidden="true"></span><span>Adding</span>');
    p.timer = setTimeout(fail, 12000);
  }, true);
  function fail() {
    if (!pending) return;
    const p = pending;
    pending = null;
    restore(p);
    if (live) g.fromTo(p.btn, {x: -7}, {x: 0, duration: 0.6, ease: 'elastic.out(1, 0.3)', clearProps: 'transform'});
  }
  document.addEventListener('pl:cart-updated', () => {
    if (pending) {
      const p = pending;
      pending = null;
      clearTimeout(p.timer);
      p.btn.classList.remove('is-adding');
      p.btn.classList.add('is-added');
      roll(p, '<span class="pl-tick" aria-hidden="true"></span><span>Added</span>');
      p.timer = setTimeout(() => {
        if (live && ours(p)) {
          roll(p, p.html);
          setTimeout(() => restore(p), 380);
        } else {
          restore(p);
        }
      }, 1700);
    }
    if (live) for (const b of document.querySelectorAll('[data-cart-count]:not([hidden])')) g.fromTo(b, {scale: 1.5}, {scale: 1, duration: 0.55, ease: 'back.out(3)', clearProps: 'transform'});
  });
  /* the error line under the form opened: the add failed */
  new MutationObserver((list) => {
    for (const m of list) if (m.target.matches('[data-pl-form-error]') && !m.target.hidden) fail();
  }).observe(document.body, {subtree: true, attributes: true, attributeFilter: ['hidden']});

  if (!live) return;

  /* ---------------------------------------------------------------- cart drawer lines */
  const drawer = document.getElementById('pl-cart');
  if (drawer) {
    let wasOpen = false;
    new MutationObserver(() => {
      const open = drawer.classList.contains('is-open');
      if (open && !wasOpen) {
        const lines = drawer.querySelectorAll('.pl-cline');
        if (lines.length) g.fromTo(lines, {x: 24}, {x: 0, duration: 0.5, stagger: 0.05, delay: 0.08, ease: 'power3.out', clearProps: 'transform'});
      }
      wasOpen = open;
    }).observe(drawer, {attributes: true, attributeFilter: ['class']});
  }

  /* ---------------------------------------------------------------- cards rise in (movement only) */
  if (window.ScrollTrigger) {
    const sel = 'main .pl-card, main .pl-ringcard, main .pl-tile, main .pl-cliprow__clip, main .pl-installs__item, main .pl-loops__item';
    const cards = [...document.querySelectorAll(sel)].filter((c) => {
      if (c.closest('[data-reveal], [hidden], dialog')) return false;
      const r = c.getBoundingClientRect();
      return r.height > 0 && r.top > innerHeight;
    });
    if (cards.length) {
      g.set(cards, {y: 32});
      window.ScrollTrigger.batch(cards, {
        start: 'top 94%',
        once: true,
        onEnter: (batch) => g.to(batch, {y: 0, duration: 0.75, stagger: 0.07, ease: 'power3.out', clearProps: 'transform'}),
      });
      /* a jump past them (an anchor, the end key) must not leave any lowered */
      addEventListener('load', () => window.ScrollTrigger.refresh(), {once: true});
    }
  }

  /* ---------------------------------------------------------------- lazy photos fade in */
  const fade = (img) => {
    if (img.dataset.plFade || img.complete || img.closest('.pl-zoom, [data-pl-zoom], .pl-pdp__media')) return;
    img.dataset.plFade = '1';
    img.style.opacity = '0';
    const back = () => g.to(img, {opacity: 1, duration: 0.5, ease: 'power1.out', clearProps: 'opacity'});
    img.addEventListener('load', back, {once: true});
    img.addEventListener('error', back, {once: true});
  };
  document.querySelectorAll('main img[loading="lazy"]').forEach(fade);
})();
